import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
    static targets = ["modal", "tokenField"]
    static values = { url: String }
    initialize() {
    }

    connect() {
        const modalElement = document.querySelector('[data-registration-token-target="modal"]')
        this.modal = new Modal(modalElement)
        this.tokenField = document.querySelector('[data-registration-token-target="tokenField"]')
    }

    async getToken(event) {
        event.preventDefault()

        try {
            const response = await fetch(this.data.get('urlValue'), {
                method: 'POST',
                headers: {
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
                    'Accept': 'application/json'
                }
            })

            const {token } = await response.json()
            this.tokenField.value = token
            this.modal.show()
        } catch (error) {
            console.error('Error:', error)
        }
    }

    closeModal() {
        let modalTarget = document.querySelector('[data-registration-token-target="modal"]')
        modalTarget.classList.remove('show');
        document.body.classList.remove('modal-open');
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) backdrop.remove();
    }

    copyToClipboard() {
        this.tokenField.select()
        navigator.clipboard.writeText(this.tokenField.value)
            .then(() => toastr.success("Токен скопирован в буфер обмена"))
            .catch(() => toastr.error("Не удалось скопировать токен"))
    }
}